var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ThemeProvider } from 'styled-components';
// Import and export all the components
import ButtonComponent from './Button/Button';
import CheckComponent from './Check/Check';
import DropdownComponent from './Dropdown/Dropdown';
import DropdownInputComponent from './DropdownInput/DropdownInput';
import ErrorComponent from './Error/Error';
import IconComponent from './Icon/Icon';
import ListComponent from './List/List';
import LoaderComponent from './Loader/Loader';
import LoadingComponent from './Loading/Loading';
import ModalComponent from './Modal/Modal';
import NewIndicatorComponent from './NewIndicator/NewIndicator';
import OnOffBallComponent from './OnOffBall/OnOffBall';
import PanelComponent from './Panel/Panel';
import SpinnerComponent from './Spinner/Spinner';
import TableComponent from './Table/Table';
import TextAreaComponent from './TextArea/TextArea';
import TextInputComponent from './TextInput/TextInput';
import ToggleComponent from './Toggle/Toggle';
import TooltipComponent from './Tooltip/Tooltip';
// Setup theme if it's passed in
import { colors as colorConstants } from './styleConstants';
var DEFAULT_THEME = {
    colors: {
        buttons: {
            primary: colorConstants.primaryBlue,
            secondary: colorConstants.primaryGreyDark,
            accent: colorConstants.accentTeal,
        },
        text: {
            primary: colorConstants.primaryBlue,
            secondary: colorConstants.primaryGreyDark,
            accent: colorConstants.accentTeal,
        },
        graphics: {
            primary: colorConstants.primaryBlue,
            secondary: '#95CEDC',
            accent: colorConstants.accentTeal,
        },
        backgrounds: {
            virtualCard: colorConstants.accentTeal,
            app: colorConstants.primaryWhite,
        },
    },
};
// Initialize with defaults!
var theme = DEFAULT_THEME;
var asThemedComponent = function (WrappedComponent) {
    return function (props) {
        return (React.createElement(ThemeProvider, { theme: theme },
            React.createElement(WrappedComponent, __assign({}, props))));
    };
};
// Initialize components as themed with our Default Theme!
var Button = asThemedComponent(ButtonComponent);
var Check = asThemedComponent(CheckComponent);
var Dropdown = asThemedComponent(DropdownComponent);
var DropdownInput = asThemedComponent(DropdownInputComponent);
var Error = asThemedComponent(ErrorComponent);
var Icon = asThemedComponent(IconComponent);
var List = asThemedComponent(ListComponent);
var Loader = asThemedComponent(LoaderComponent);
var Loading = asThemedComponent(LoadingComponent);
var Modal = asThemedComponent(ModalComponent);
var NewIndicator = asThemedComponent(NewIndicatorComponent);
var OnOffBall = asThemedComponent(OnOffBallComponent);
var Panel = asThemedComponent(PanelComponent);
var Spinner = asThemedComponent(SpinnerComponent);
var Table = asThemedComponent(TableComponent);
var TextArea = asThemedComponent(TextAreaComponent);
var TextInput = asThemedComponent(TextInputComponent);
var Toggle = asThemedComponent(ToggleComponent);
var Tooltip = asThemedComponent(TooltipComponent);
function setStyledComponentsTheme(customerTheme) {
    // TODO(Carter): Validate customer theme passed in or deep merge!
    if (customerTheme) {
        theme = customerTheme;
    }
    // Re-assign the values so the exported bindings pick up the new theme!
    Button = asThemedComponent(ButtonComponent);
    Check = asThemedComponent(CheckComponent);
    Dropdown = asThemedComponent(DropdownComponent);
    DropdownInput = asThemedComponent(DropdownInputComponent);
    Error = asThemedComponent(ErrorComponent);
    Icon = asThemedComponent(IconComponent);
    List = asThemedComponent(ListComponent);
    Loader = asThemedComponent(LoaderComponent);
    Loading = asThemedComponent(LoadingComponent);
    Modal = asThemedComponent(ModalComponent);
    NewIndicator = asThemedComponent(NewIndicatorComponent);
    OnOffBall = asThemedComponent(OnOffBallComponent);
    Panel = asThemedComponent(PanelComponent);
    Spinner = asThemedComponent(SpinnerComponent);
    Table = asThemedComponent(TableComponent);
    TextArea = asThemedComponent(TextAreaComponent);
    TextInput = asThemedComponent(TextInputComponent);
    Toggle = asThemedComponent(ToggleComponent);
    Tooltip = asThemedComponent(TooltipComponent);
}
// Use es6 exports to export bindings to the variables here!
// If a customer calls setStyledComponentsTheme, it will update
// the values of the bindings and re-theme the components!
// See this page for an explanation:
//   https://2ality.com/2015/07/es6-module-exports.html
export { Button, Check, Dropdown, DropdownInput, Error, Icon, List, Loader, Loading, Modal, NewIndicator, OnOffBall, Panel, setStyledComponentsTheme, Spinner, Table, TextArea, TextInput, Toggle, Tooltip, };
